var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"breadcrumb is-small",attrs:{"aria-label":"breadcrumbs"}},[_c('ul',_vm._l((_vm.breadcrumbItems),function(crumb,index){return _c('li',{key:index,class:{ 'is-active': crumb.isActive }},[_c('a',{attrs:{"href":"#","aria-current":"page"}},[_vm._v(" "+_vm._s(crumb.name)+" ")])])}))])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AppBreadcrumb.Vue?vue&type=template&id=45010efe
// module id = 149
// module chunks = 0